import fromMap from './from-map';
import fromType from './from-type';
export { fromMap, fromType };